<template>
  <div class="source-inline">
    <slot />
  </div>
</template>

<style scoped lang="scss">

  .source-inline {
    color: var(--color-gray-40);

    @include number-small;
  }
</style>
